import { OpoContactProfileModal } from '@lp/features/modals/OpoContactProfileModal/OpoContactProfileModal';
import { TmdxResourceCard } from '@features/components/ResourceCards';
import { ConditionalRender, ResourceAvatarStatusChipType } from '@ui';
import { MdOutlineWifiTethering } from 'react-icons/md';
import { WithDetachResourceModal } from '@features/components/CaseOverview/components/AssignedResources/WithDetachResourceModal';
import { getUserMenuItems } from '@features/components/CaseOverview/components/AssignedResources/userMenu.config';
import { useDetachOpoContact } from '@features/components/CaseOverview/components/AssignedResources/hooks/useDetachOpoContact';
import { ResourceSection } from '../ResourceSection';
import { NoContacts } from '../NoContacts';
import { getFullName, getContactFullName } from '@/utils/helpers';
import { Uuid } from '@/api/types';
import { AssignedOpoContactType, CaseFacility } from '@/api/apis/case';

type OpoContactsProps = {
  opoContacts: AssignedOpoContactType[];
  opo: CaseFacility;
  caseId: Uuid;
  menuDisabled: boolean;
};

const getOpoContactStatusChipType = (isOpoUser: boolean) =>
  isOpoUser ? ResourceAvatarStatusChipType.OpoUser : ResourceAvatarStatusChipType.OpoContact;

export const OpoContacts = ({ menuDisabled, opoContacts, opo, caseId }: OpoContactsProps) => {
  const { handleDetach, isPendingDetach } = useDetachOpoContact({ caseId });

  return (
    <ResourceSection title="OPO Contacts" count={opoContacts.length}>
      <ConditionalRender show={!!opoContacts.length} placeholder={<NoContacts />}>
        {opoContacts.map((opoContact) => (
          <div key={opoContact.id} className="w-80">
            <WithDetachResourceModal
              isPending={isPendingDetach}
              onDetachSubmit={() => handleDetach(opoContact.id)}
              photo={opoContact.photoPath || ''}
              name={getFullName(opoContact.firstName, opoContact.lastName)}
            >
              {({ onOpenChange }) => (
                <OpoContactProfileModal contact={opoContact}>
                  <TmdxResourceCard
                    icon={opoContact.isOpoUser ? <MdOutlineWifiTethering className="text-base-20" /> : null}
                    showChip={false}
                    menuDisabled={menuDisabled}
                    list={getUserMenuItems({ onDetachPress: onOpenChange })}
                    type="user"
                    title={getContactFullName(opoContact?.firstName, opoContact?.lastName)}
                    subTitle={opo?.name || ''}
                    phoneNumber={opoContact?.primaryPhone}
                    avatarProps={{
                      src: opoContact?.photoPath,
                      isStatus: true,
                      statusChip: {
                        type: getOpoContactStatusChipType(opoContact.isOpoUser),
                      },
                    }}
                  />
                </OpoContactProfileModal>
              )}
            </WithDetachResourceModal>
          </div>
        ))}
      </ConditionalRender>
    </ResourceSection>
  );
};
